var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._g({staticClass:"action",attrs:{"type":"button"}},_vm.$listeners),[_c('AppDownloadIcon'),(_vm.label)?_c('span',{staticClass:"action__label"},[_vm._v(_vm._s(_vm.label))]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }